import usePage from "../page-hook";
import {useEffect} from "react";
import StickyToolbar,{IProps} from "../../sticky-toolbar/sticky-toolbar";

interface IBaseLayoutStickyToolbar extends Pick<IProps, 'placement' | 'children'> {}

const BaseLayoutStickyToolbar: React.FC<IBaseLayoutStickyToolbar> = ({ placement, children }) => {
    const { width, setBottomPadding } = usePage();

    useEffect(() => {
        return () => {
            setBottomPadding(null);
        };
    }, [setBottomPadding]);

    const onResize = ({ height = 0 }) => {
        setBottomPadding(height);
    }

    return (
        <StickyToolbar
            placement={placement}
            onResize={onResize}
            width={width}
        >{children}</StickyToolbar>
    );
}

export default BaseLayoutStickyToolbar;